/**
 *
 * Distance display
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LeafletControlPanel from 'components/LeafletControlPanel';
import Distance from 'components/Distance';

const Wrapper = styled(LeafletControlPanel)`
  padding: 5px;
  height: 38px;
  font-size: 12px;
  .distance-digits {
    font-size: 1.8em;
    font-weight: bold;
  }
  @media (min-width: 400px) {
    padding: 5px 10px;
    font-size: 14px;
    height: 50px;
  }
`;

function DistancePanel(props) {
  const { distance } = props;
  // const distanceString = (distance / 1000).toFixed(2);
  return (
    <Wrapper>
      <Distance distance={distance / 1000} decimals={2} />
    </Wrapper>
  );
}

DistancePanel.propTypes = {
  distance: PropTypes.number,
};

export default DistancePanel;
